<template>
    <v-dialog v-model="dialog" max-width="650">
        <template #activator="{on}">
            <v-btn v-on="on">
                <v-icon left>mdi-play-box-outline</v-icon>
                Create Pending Box
            </v-btn>
        </template>
        <v-card :disabled="loading" :loading="loading">
            <v-card-title>Create Pending Box</v-card-title>
            <v-card-text>
                <v-text-field v-model="name" label="Name" required></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="dialog=false">Cancel</v-btn>
                <v-spacer />
                <v-btn @click="addBox">Add</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    data: () => ({
        name: "",
        dialog:false
    }),
    computed:{
        ...mapGetters("pendingbox", ["loading"])
    },
    methods:{
        ...mapActions("pendingbox", ["add"]),
        addBox(){
            if(this.name){
                this.add({name:this.name, code:this.name})
                .then(() => {
                    this.dialog = false;
                    this.name = "";
                })
            }
        }
    }
}
</script>

<style>

</style>